<script setup lang="ts">
defineOptions({
	name: 'ForceMajeureSection',
})

const { t: $t, locale } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'{company} shall not be held liable to {users}, nor deemed in default or breach of these {terms_conditions}, in the event of any failure or delay in fulfilling or performing its obligations, provided that such failure or delay is caused by by an event of force majeure or fortuitous event {force_majeure_events}, as recognised under Portuguese law.',
		{
			users: `<span class="font-semibold">${$t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
			terms_conditions: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			force_majeure_events: `(“<span class="font-semibold">${$t('Force Majeure Events')}</span>”)`,
		},
	)
})

const extraHtml = computed(() => {
	return $tThird('For the purposes of this clause, {force_majeure_events} include, but are not limited to:', {
		force_majeure_events: `“<span class="font-semibold">${$t('Force Majeure Events')}</span>”`,
	})
})

const eventFirst = computed(() => {
	return $tThird('Embargoes or blockades in effect on or after the date of these {terms}.', {
		terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
	})
})

const eventSecond = computed(() => {
	return $tThird('Other similar events beyond {company} control.', {
		company: `<span class="font-semibold">${locale.value !== 'en' ? 'Gaveta Decimal' : 'Gaveta Decimal’s'}</span>`,
	})
})

const secondHtml = computed(() => {
	const company = '<span class="font-semibold">Gaveta Decimal</span>'
	return $tThird(
		'Should {companies} failure or delay continue for 45 (forty-five) consecutive days following written notice to {users} as outlined in this Section, {company} may subsequently terminate these {terms} with 15 (fifteen) days’ written notice.',
		{
			companies: locale.value !== 'en' ? company : '<span class="font-semibold">Gaveta Decimal’s</span>',
			company,
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
		},
	)
})

const thirdHtml = computed(() => {
	return $tThird(
		'{company} will work diligently to resolve the issue and minimise the effects of the Force Majeure Event, resuming its obligations as soon as reasonably possible once the cause is resolved.',
		{
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:flash-on-outline"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">{{ $t('Force Majeure') }}</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p v-html="extraHtml"></p>
			<ul class="list-disc pl-7 space-y-2.5">
				<li>{{ $t('Acts of God') }}.</li>
				<li>{{ $tThird('Flood, fire, earthquake, epidemics, pandemics, tsunami, explosion') }}.</li>
				<li>
					{{
						$tThird(
							'War, invasion, hostilities (whether declared or not), terrorist threats or acts, riot, or other civil unrest',
						)
					}}.
				</li>
				<li>{{ $tThird('Government orders, laws, or actions') }}.</li>
				<li v-html="eventFirst"></li>
				<li>{{ $tThird('Strikes, labour stoppages, slowdowns, or other industrial disturbances') }}.</li>
				<li>
					{{
						$tThird(
							'Shortages of adequate or suitable internet connectivity, telecommunications breakdown, or shortages of adequate power or electricity',
						)
					}}.
				</li>
				<li v-html="eventSecond"></li>
			</ul>
			<p>{{ $tThird('In the event of a Force Majeure Event, Gaveta Decimal shall') }}:</p>
			<ul class="list-disc pl-7 space-y-2.5">
				<li>
					{{
						$tThird(
							'Promptly notify Users of the occurrence, including, where possible, an estimate of its expected duration',
						)
					}};
				</li>
				<li>
					{{
						$tThird(
							'Use all reasonable efforts to mitigate the impact of the Force Majeure Event and resumeperformance of its obligations as soon as reasonably possible',
						)
					}}.
				</li>
			</ul>

			<p v-html="thirdHtml"></p>
			<p v-html="secondHtml"></p>
		</div>
	</section>
</template>
